// import axios, { AxiosResponse, AxiosRequestConfig } from "axios";

// const api = axios.create({
//   baseURL: process.env.NEXT_PUBLIC_API_URL,
//   timeout: 20000,
//   headers: {
//     "Content-Type": "application/json",
//     Accept: "application/json",
//   },
//   withCredentials: true,
// });

// interface RequestParams<T> {
//   endpoint: string;
//   data?: T;
//   config?: AxiosRequestConfig;
// }

// // const isTokenExpired = () => {
// //   const cookie = document.cookie
// //     .split(";")
// //     .find((cookie) => cookie.includes("accessTokenExpire"));
// //   if (!cookie) return true;

// //   const expires = cookie.split("=")[1];
// //   if (Date.now() > expires) return true;
// // };

// // const refreshToken = async () => {
// //   const response: AxiosResponse<R> = await api.post(endpoint, data, config);
// //   let res = response.data;
// //   res.status = response.status;
// //   return res;
// // };

// interface ResponseData<R> extends R {
//   status: any;
// }

// async function request<T, R = any>({
//   endpoint,
//   data,
//   config = {},
// }: RequestParams<T>): Promise<ResponseData<R> | undefined> {
//   try {
//     // if (endpoint.startsWith("/api/")) {
//     //   if (isTokenExpired) {
//     //   }
//     // }
//     const method = data ? "post" : "get";
//     const response: AxiosResponse<R> = await api[method](
//       endpoint,
//       data,
//       config
//     );
//     // let res = response.data;
//     let res: ResponseData<R> = response.data as ResponseData<R>;
//     res.status = response.status;
//     return res;
//   } catch (error) {
//     if (axios.isAxiosError(error)) {
//       let res = error.response?.data;
//       // res.status = error.status;
//       res.status = error.response?.status;
//       res.error = error.code + ": " + error.message;
//       if (
//         (res.status === 401 || res.status === 403) &&
//         endpoint.startsWith("/api/")
//       ) {
//         window.location.href = "/login";
//       } else {
//         return res;
//       }
//     } else {
//       console.error("Unexpected error:", error);
//       throw new Error("خطای غیر منتظره رخ داده است");
//     }
//   }
//   return undefined;
// }

// export { request };

import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

interface ApiCallOptions {
  url: string;
  body?: any; // Optional body for POST requests
  withCredentials?: boolean;
}

const request = <T>({
  url,
  body = null,
  withCredentials = true,
}: ApiCallOptions): Promise<T> => {
  // const request = (url, body = null, headers = {}) => {
  return new Promise((resolve, reject) => {
    const config: AxiosRequestConfig = {
      url,
      method: body ? "POST" : "GET",
      headers: {
        "Content-Type": "application/json",
      },
      data: body || null,
      baseURL: process.env.NEXT_PUBLIC_API_URL,
      withCredentials: withCredentials,
    };

    axios(config)
      .then((response: AxiosResponse<T>) => {
        // console.log(response);

        let res: any = response.data;
        res.status = response.status;
        resolve(res);
      })
      .catch((error) => {
        console.log(error);

        let err = null;
        if (error.response) {
          err = error.response.data;
          err.status = error.response.status;
        } else {
          err = error.message;
          err.status = error.status ? error.status : null;
        }
        reject(err);
      });
  });
};

// const request = (url, body = null, withCredentials = true) =>
//   new Promise((resolve, reject) => {
//     const config = {
//       url,
//       method: body ? "POST" : "GET",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: body,
//       baseURL: process.env.NEXT_PUBLIC_API_URL,
//       withCredentials: withCredentials,
//     };

//     axios(config)
//       .then((response: AxiosResponse) => {
//         let res = response.data;
//         res.status = response.status;
//         resolve(res);
//       })
//       .catch((error) => {
//         console.log(error);
//         let err = null;
//         if (err.response) {
//           err = error.response.data;
//           err.status = response.status;
//         } else {
//           err = error.message;
//           err.status = error.status ? error.status : null;
//         }
//         reject(err);
//       });
//   });

export default request;
